export function renderBuildRestoreManyToManyStatementsValueTemplate({
  fieldName,
  junctionVar,
  entityIdCol,
  relSingular,
  relIdCol
}: {
  fieldName: string
  junctionVar: string
  entityIdCol: string
  relSingular: string
  relIdCol: string
}): string {
  return `      const ${fieldName}Value = versionData.${fieldName}
      const ${fieldName}Ids = Array.isArray(${fieldName}Value)
        ? ${fieldName}Value.filter((id): id is string => typeof id === 'string')
        : []
      await tx.delete(${junctionVar}).where(eq(${junctionVar}.${entityIdCol}, versionRow.entityId))
      if (${fieldName}Ids.length > 0) {
        await tx.insert(${junctionVar}).values(
          ${fieldName}Ids.map((${relSingular}Id) => ({
            ${entityIdCol}: versionRow.entityId,
            ${relIdCol}: ${relSingular}Id
          }))
        )
      }`
}
